import React from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import { setField } from 'manager/redux/referral_status'
import { FINANCING } from 'common/constants'

const FinancingDropdown = ({ financeType, setField }) => {
    const onChange = option => setField('financeType', option && option.value)

    return (
        <div className="FinancingCategoryDropdown">
            <label>Payment Type</label>
            <Select
              options={FINANCING}
              value={financeType}
              onChange={onChange}
              clearable={false}
              backspaceRemoves={false}
            />
        </div>
    )
}

const selector = state => {
    const financeType = _.get(state, ['referralStatus', 'financeType'], 'financing')

    return { financeType }
}

const actions = {
    setField
}

export const FinancingCategoryDropdown = connect(selector, actions)(FinancingDropdown)
